import { UPDATE_CONFERENCE_METADATA } from '../../../react/features/base/conference/actionTypes';
import { getCurrentConference } from '../../../react/features/base/conference/functions';
import MiddlewareRegistry from '../../../react/features/base/redux/MiddlewareRegistry';
import { SET_REQUESTING_SUBTITLES } from '../../../react/features/subtitles/actionTypes';
import { setRequestingSubtitles } from '../../../react/features/subtitles/actions.any';
import { isTranscribing } from '../../../react/features/transcribing/functions';
import WildixXMPPEvents from '../../../wildix/service/xmpp/WildixXMPPEvents';
import { updateLang } from '../conference/actions.any';
import { isMetaWildixTranscriptionDisabled, transcriptionLanguagesCopied } from './actions.any';
/**
 * Implements the entry point of the middleware of the xbees/base/conference.
 *
 * @param {Store} store - The redux store.
 * @returns {Function}
 */
MiddlewareRegistry.register(store => next => action => {
    const result = next(action);
    switch (action.type) {
        case SET_REQUESTING_SUBTITLES: {
            const { dispatch } = store;
            const { language } = action;
            if (!language) {
                break;
            }
            dispatch(updateLang(language));
            break;
        }
        case UPDATE_CONFERENCE_METADATA: {
            const { dispatch, getState } = store;
            const { metadata } = action;
            if (!metadata) {
                break;
            }
            const state = getState();
            if (isMetaWildixTranscriptionDisabled(state) && isTranscribing(state)) {
                const conference = getCurrentConference(state);
                dispatch(setRequestingSubtitles(false, false, null));
                dispatch(transcriptionLanguagesCopied('', ''));
                // @ts-ignore
                conference.removeLocalParticipantProperty(WildixXMPPEvents.TRANSCRIPTION_LANGUAGE);
            }
            break;
        }
    }
    return result;
});
